import { Search as SearchIcon } from '@mui/icons-material';
import { Autocomplete, Box, TextField, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';

interface SectionFilterHeaderProps {
    searchValue: string;
    onSearchChange: (value: string) => void;
    searchLabel: string;
    searchOptions?: Array<{ title: string; id: string | number }>;
    children?: React.ReactNode;
}

function SectionFilterHeader({
    searchValue,
    onSearchChange,
    searchLabel,
    searchOptions = [],
    children,
}: SectionFilterHeaderProps) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                alignItems: 'center',
                gap: 2,
                mb: 2,
                p: 2,
                bgcolor: `${theme.palette.primary.main}08`,
                borderRadius: 1,
                border: `1px solid ${theme.palette.primary.main}20`,
            }}
        >
            <Autocomplete
                freeSolo
                options={searchOptions}
                getOptionLabel={(option) => (typeof option === 'string' ? option : option.title)}
                inputValue={searchValue}
                onInputChange={(_, newValue) => onSearchChange(newValue || '')}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        size="small"
                        placeholder={searchLabel}
                        InputProps={{
                            ...params.InputProps,
                            startAdornment: <SearchIcon sx={{ color: 'text.secondary', mr: 1 }} />,
                            sx: {
                                borderRadius: '32px',
                                padding: '4px',
                                height: '32px',
                                '& .MuiOutlinedInput-input': {
                                    padding: '4px 8px',
                                },
                                '& .MuiOutlinedInput-notchedOutline': {
                                    borderRadius: '32px',
                                },
                            },
                        }}
                    />
                )}
                sx={{
                    flex: 1,
                    minWidth: 200,
                    '& .MuiAutocomplete-popper': {
                        zIndex: 1500,
                    },
                }}
            />

            {children}
        </Box>
    );
}

export default SectionFilterHeader;
